import { useTranslation } from 'react-i18next'

export default function AboutPage() {
  const { t } = useTranslation()
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">{t('common.about')}</h1>
      <p className="text-gray-700 dark:text-gray-300 leading-7">
        {t('about.description', 'Sakeena is a platform that offers prayer times, Zakat calculator, Quran reading, an Islamic library, and more—built for multi-language audiences with RTL/LTR support.')}
      </p>
    </div>
  )
}


